import React from 'react';
import { Container, Typography, Box, Paper, Divider, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const RGPDPage = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ bgcolor: '#f5f7fa', minHeight: '100vh', py: 8 }}>
            <Container maxWidth="md">
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(-1)}
                    sx={{ mb: 4, textTransform: 'none' }}
                >
                    Retour
                </Button>

                <Paper elevation={0} sx={{ p: { xs: 4, md: 6 }, borderRadius: 4, border: '1px solid #e2e8f0' }}>
                    <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#2d3748' }}>
                        Politique RGPD
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        Conformité au Règlement Général sur la Protection des Données
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Box sx={{ mt: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            1. Collecte des Données
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Dans le cadre de l'utilisation de la plateforme, nous collectons des données à caractère personnel (nom, prénom, email, logs de connexion, progression pédagogique) nécessaires à l'exécution de la prestation de formation.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            2. Finalités du Traitement
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Les données sont traitées pour les finalités suivantes : gestion des comptes utilisateurs, suivi de l'émargement et de l'assiduité, évaluation des connaissances, et support technique.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            3. Destinataires des Données
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Les données sont destinées exclusivement au Prestataire, à l'Organisme de Formation client, et aux éventuels sous-traitants techniques intervenant dans le strict respect de la confidentialité.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            4. Durée de Conservation
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Les données sont conservées pendant la durée d'exécution du contrat de formation et pendant les durées légales de conservation imposées par les autorités de contrôle de la formation professionnelle.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            5. Vos Droits
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Conformément à la réglementation, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition au traitement de vos données. Vous pouvez exercer ces droits en contactant le Délégué à la Protection des Données (DPO) à l'adresse email : privacy@edu-jalm.fr.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            6. Sécurité
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé ou toute perte.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            7. Hébergement et Souveraineté des Données
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ fontWeight: 600, color: '#2c5282' }}>
                            Afin de garantir une souveraineté numérique maximale et la protection de vos données, l'intégralité de nos infrastructures est physiquement située sur le territoire français.
                        </Typography>

                        <Typography variant="body1" sx={{ mt: 2, fontWeight: 700 }}>
                            Hébergement de l'Application :
                        </Typography>
                        <Typography variant="body1" paragraph>
                            o2switch<br />
                            Chemin des Pardiaux<br />
                            63000 Clermont-Ferrand<br />
                            Capital de 100 000€ - Siret 510 909 807 00032
                        </Typography>

                        <Typography variant="body1" sx={{ mt: 2, fontWeight: 700 }}>
                            Hébergement de la Base de Données :
                        </Typography>
                        <Typography variant="body1" paragraph>
                            OVH GRAVELINES<br />
                            59820 GRAVELINES<br />
                            France
                        </Typography>

                        <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 2 }}>
                            Ce choix d'hébergeurs français garantit que vos données ne sont pas soumises à des législations extra-européennes et bénéficient du plus haut niveau de protection juridique au sein de l'Union Européenne.
                        </Typography>

                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mt: 4 }}>
                            8. Suivi des Communications (Tracking)
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Afin d'assurer le suivi pédagogique et administratif de la formation, les emails envoyés depuis la plateforme contiennent des pixels de suivi permettant de confirmer leur ouverture. Cette donnée technique est conservée à titre de preuve d'envoi et de réception des convocations et informations pédagogiques obligatoires.
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default RGPDPage;
